import type { Setting } from '@models/setting';
import { useQuery } from '@tanstack/react-query';
import { getSetting, getSettings } from './api';

export function useSettingsQuery() {
  return useQuery<Setting[]>({
    queryKey: ['settings'],
    queryFn: getSettings,
  });
}

export function useSettingQuery(id: string) {
  return useQuery<Setting>({
    queryKey: ['setting', id],
    queryFn: () => getSetting(id),
  });
}
